import { render, staticRenderFns } from "./bulkExample.vue?vue&type=template&id=5313fe56&class=ml-10&"
import script from "./bulkExample.vue?vue&type=script&lang=js&"
export * from "./bulkExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports